import {authorizationServicesPath, estimateServicesPath, ordersServicesPath} from "../../Constants";
import axios from "axios";

const authorizationRestUrl = authorizationServicesPath + '/admin/cache'
const ordersRestUrl = ordersServicesPath + '/admin/cache'
const modelEstimateRestUrl = estimateServicesPath + '/admin/cache'

export default class AdminCacheControllerService {
    static async authorizationCurrencies() {
        return await axios.post(authorizationRestUrl + "/delete-currencies", [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async authorizationAll() {
        return await axios.delete(authorizationRestUrl, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async modelEstimateUnits() {
        return await axios.post(modelEstimateRestUrl + "/delete-units", [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async modelEstimateAll() {
        return await axios.delete(modelEstimateRestUrl, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async ordersUnits() {
        return await axios.post(ordersRestUrl + "/delete-units", [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async ordersManufacturers() {
        return await axios.post(ordersRestUrl + "/delete-manufacturers", [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async ordersCurrencies() {
        return await axios.post(ordersRestUrl + "/delete-currencies", [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async ordersAll() {
        return await axios.delete(ordersRestUrl, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
}